export const PredictionWorker = function () {
    importScripts("https://cdn.jsdelivr.net/npm/lodash@4.17.21/lodash.min.js");

    const predictRecordsCount = (props) => {
        const {
            types,
            dimensions,
            dates,
            sections,
            indicators,
            jts,
            layout,
            options,
            limits = {},
            tableOrChart,
            listJT,
            listSC,
            listWSK,
            CUSTOM_SELECTED_POSITIONS,
            PREDICTION_DATA,
        } = props;

        let _result = {
            _complete: false,
            _recordsCount: 0,
            _rowsCount: 0,
            _accepted: true,
            _acceptedInfo: {
                cols: true,
                rows: true,
                records: true,
            },
            _limits: {
                columns: 0,
                rows: 0,
                records: 0,
            },
            COUNTER: {
                leftCount: 0,
                rightCount: 0,
                totalCount: 0,
            },
            _errMessage: "",
            _errMessageShort: "",
            PREDICTION_DATA,
        };

        const selectedJTs = structuredClone(jts || []);
        const selectedIndicators = structuredClone(indicators || []);
        const multiSections = structuredClone(sections || {});
        const selectedPositions = structuredClone(CUSTOM_SELECTED_POSITIONS || []);
        const selectedDates = structuredClone(dates || []);

        const _datesCount = listSC ? 1 : selectedDates?.length;
        const _jtsCount = listJT ? 1 : selectedJTs?.length;
        const _wsk = listWSK ? [listWSK.indicator_id] : selectedIndicators?.map((i) => i.indicator_id);

        let _recordsTotal = 0;

        try {
            const _selPosSums = [];
            _wsk?.forEach((WSK) => {
                multiSections[WSK]?.forEach((SECTION) => {
                    const _selPosMultipliers = [];

                    const multiGroupBy = (seq, keys) => {
                        if (!keys.length) {
                            _selPosMultipliers.push(seq.length);
                            return seq;
                        }
                        var first = keys[0];
                        var rest = keys.slice(1);
                        return _.mapValues(_.groupBy(seq, first), function (value) {
                            return multiGroupBy(value, rest);
                        });
                    };

                    multiGroupBy(
                        selectedPositions?.filter((s) => s.indicator_id === WSK && s.section_id === SECTION),
                        ["section_id", "dimension_id"]
                    );
                    const amount = _selPosMultipliers.reduce(
                        (accumulator, currentValue) => accumulator * currentValue,
                        1
                    );
                    _selPosSums.push(amount);
                });
            });
            const amount = _selPosSums.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
            _recordsTotal = _datesCount * _jtsCount * amount;

            let TYPE_LIMIT = structuredClone(limits?.[tableOrChart] || {});

            const _recordsCount = _recordsTotal;

            const _accepted = _recordsCount <= TYPE_LIMIT.records;

            const _acceptedInfo = { cols: true, rows: true, records: _recordsCount <= TYPE_LIMIT.records };

            const _errMessageShort = !_accepted;

            let _errMessage = "";

            _result = {
                _complete: tableOrChart in limits,
                _recordsCount,
                _accepted,
                _acceptedInfo,
                _limits: TYPE_LIMIT,
                COUNTER: { records: _recordsCount },
                _errMessage,
                _errMessageShort,
                PREDICTION_DATA,
            };
        } catch (error) {
            if (process.env.NODE_ENV === "development") {
                console.log(`%c prediction ~ error:`, "background: #F00; color: #FFF", error, `\n`, { _result });
            }
        }

        return _result;
    };

    self.addEventListener("message", (event) => {
        // eslint-disable-line no-restricted-globals
        if (!event || !event.data) return;

        const result = predictRecordsCount(event.data);

        postMessage(result);
    });
};
